import React from "react";
import { Box, HStack, Icon, SimpleGrid, Stat, StatLabel, StatNumber, Text, useColorModeValue } from "@chakra-ui/react";
import { BsCheck2Circle, BsClockHistory, BsFiles, BsXCircle } from "react-icons/bs";
import { formatNumber } from "../../utils/riskReviewFormatters";

const RiskReviewStatsGrid = ({ stats = {} }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const iconBg = useColorModeValue("blue.50", "gray.700");
  const byStatus = stats.byStatus || {};
  const total = Object.values(byStatus).reduce((sum, value) => sum + Number(value || 0), 0);
  const kpis = [
    { label: "Total Requests", value: total, icon: BsFiles, color: "blue.500" },
    { label: "Pending Approval", value: byStatus.PENDING_APPROVAL || 0, icon: BsClockHistory, color: "orange.500" },
    { label: "Approved", value: byStatus.APPROVED || 0, icon: BsCheck2Circle, color: "green.500" },
    { label: "Rejected", value: byStatus.REJECTED || 0, icon: BsXCircle, color: "red.500" },
  ];

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, xl: 4 }} spacing={4}>
      {kpis.map((item) => (
        <Box key={item.label} bg={cardBg} borderWidth="1px" borderColor={borderColor} borderRadius="md" p={4} boxShadow="sm">
          <HStack justify="space-between" align="flex-start">
            <Stat>
              <StatLabel color="gray.500">{item.label}</StatLabel>
              <StatNumber fontSize="2xl">{formatNumber(item.value)}</StatNumber>
            </Stat>
            <Box bg={iconBg} borderRadius="md" p={2}>
              <Icon as={item.icon} color={item.color} boxSize={5} />
            </Box>
          </HStack>
          <Text color="gray.500" fontSize="xs" mt={3}>
            Current tenant scope
          </Text>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default RiskReviewStatsGrid;
